import { createFileRoute } from "@tanstack/react-router"
import { BackofficeOrganizationDetail } from "modules/backoffice/components/organizations/BackofficeOrganizationDetail"

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/$id/")({
  component: BackofficeOrganizationDetail,
})
